import Vue from 'vue';
import VueRouter from 'vue-router';

// 懒加载路由并命名 chunk 文件
const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home/index.vue')
const Writemail = () => import(/* webpackChunkName: "writemail" */ '@/views/WriteMail')
const Viewmail = () => import(/* webpackChunkName: "viewmail" */ '@/views/ViewMail')
const Preview = () => import(/* webpackChunkName: "preview" */ '@/views/Preview')
const Search = () => import(/* webpackChunkName: "search" */ '../views/Search/index.vue')
const Dom = () => import(/* webpackChunkName: "Dom" */ '../views/dom.vue')
const page404 = () => import(/* webpackChunkName: "page404" */ '@/views/Page404')
const Select = () => import(/* webpackChunkName: "Select" */ '@/components/SelectEma')

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true //此组件需要被缓存
    }
  },
  {
    path: "/search",
    name: "Search",
    component: Search,
    meta: {
      keepAlive: true //此组件不需要被缓存
    }
  },
  {
    path: '/writemail',
    name: 'Writemail',
    component: Writemail,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/viewmail',
    name: 'Viewmail',
    component: Viewmail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/preview',
    name: 'Preview',
    component: Preview,
    meta: {
      keepAlive: false
    }

  },
  {
    path: '/select',
    name: 'Select',
    component: Select,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/dom',
    name: 'dom',
    component: Dom,
    meta: {
      keepAlive: false
    }
  },
  // 404页面放在最后定义
  {
    path: '*',
    name: 'page404',
    component: page404
  }
];


const router = new VueRouter({
  mode: "history",
  routes,
});
router.beforeEach((to, form, next) => {
  console.log("路由跳转", to, form);
  if (to.path === "/ewsapi/login/loginredirect" && to.query.ticket) {
    next({
      path: `/?ticket=${to.query.ticket}`,
    });
  } else {
    next();
  }
});
export default router;
